var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInbound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6185 64.8337L48.1763 71.7523L51.3132 75.1196L64.8453 62.5336L51.3132 49.9476L48.1763 53.3149L55.6185 60.2336H31.2956C25.9509 60.2336 21.5996 55.8818 21.5996 50.5364L21.6088 37.5732H17V50.5364C17 58.4211 23.4119 64.8337 31.2956 64.8337H55.6185Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4736 38.6313C93.4644 38.2265 93.354 37.8217 93.1148 37.4537C93.1056 37.4445 93.1056 37.4353 93.0964 37.4168V37.4076C93.0964 37.4076 93.0964 37.4076 93.0964 37.3984L84.1547 23.9936C83.7408 23.3772 83.0416 23 82.2965 23H41.7278C40.9827 23 40.2835 23.3772 39.8695 23.9936L30.9279 37.4076C30.9279 37.4076 30.9279 37.4168 30.9187 37.4168V37.4261C30.9095 37.4353 30.9095 37.4445 30.9003 37.4537C30.6795 37.7941 30.5507 38.1989 30.5415 38.6313C30.5415 38.6405 30.5415 38.6497 30.5415 38.6681V38.6773V38.6865V54.8882H35.0123V40.9038H53.0613H57.5321H66.483H70.9538H89.0027V82.4891H35.0215V69.6087H30.5507V87.0892H30.6795H35.0307H89.0211H93.2436H93.5012V38.6773V38.6681V38.6589C93.4828 38.6497 93.4736 38.6405 93.4736 38.6313ZM59.7215 36.4232H36.9626L42.9237 27.4713H59.7215V36.4232ZM64.1924 36.4232V27.4713H81.0914L87.0525 36.4232H64.1924Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbound);
export default __webpack_public_path__ + "static/media/icon-inbound.b5e8fbb8dc2523504fbd38269ffd7b4a.svg";
export { ForwardRef as ReactComponent };